import './PageHero.css';

const PageHero = ({ title, subtitle, eyebrow = 'The Video Company', align = 'center' }) => {
  return (
    <section className="page-hero">
      <div className="page-hero__background" aria-hidden />
      <div className={`page-hero__content page-hero__content--${align}`}>
        <p className="page-hero__eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;

